const PILLOW_TEMPLATE_SELECTOR =
  "#MainContent[data-template='product.merowen-pillow-covers']";
const PILLOW_CONTACT_SELECTOR =
  '[data-merowen-pillow-product-section-type="contact"]';
const PILLOW_CONTACT_INSTANCES = new WeakMap();

function markPillowAssetsReady(root = document) {
  const templateRoot =
    root.matches?.(PILLOW_TEMPLATE_SELECTOR)
      ? root
      : root.querySelector?.(PILLOW_TEMPLATE_SELECTOR);

  if (templateRoot) {
    templateRoot.dataset.merowenPillowProductAssets = 'ready';
  }
}

function initPillowContact(root) {
  if (!root || PILLOW_CONTACT_INSTANCES.has(root)) return;

  const form = root.querySelector('[data-merowen-pillow-product-contact-form]');
  const message = root.querySelector('[data-merowen-pillow-product-contact-message]');
  const submit = root.querySelector('[data-merowen-pillow-product-contact-submit]');
  const submitLabel = root.querySelector('[data-merowen-pillow-product-contact-submit-label]');
  const success = root.querySelector('[data-merowen-pillow-product-contact-success]');

  if (!form) return;

  const updateError = (input) => {
    const field = input.closest('.merowen-pillow-product__contact-field');
    const error = field?.querySelector('[data-merowen-pillow-product-contact-error]');
    if (!error) return;

    const invalid = !input.validity.valid;
    error.textContent = invalid ? input.validationMessage : '';
    error.classList.toggle('is-visible', invalid);

    if (invalid) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };

  const restoreSubmit = () => {
    if (!submit) return;
    submit.disabled = false;
    submit.removeAttribute('aria-disabled');
    submit.removeAttribute('aria-busy');
    if (submitLabel) submitLabel.textContent = submit.dataset.defaultLabel || 'SEND MESSAGE';
  };

  const onInvalid = (event) => {
    if (!event.target.matches('[data-merowen-pillow-product-contact-input]')) return;
    updateError(event.target);
  };

  const onInput = (event) => {
    if (!event.target.matches('[data-merowen-pillow-product-contact-input]')) return;
    updateError(event.target);
  };

  const onSubmit = () => {
    if (!form.checkValidity() || !submit) return;
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');
    submit.setAttribute('aria-busy', 'true');
    if (submitLabel) {
      submitLabel.textContent = submit.dataset.submittingLabel || 'SENDING...';
    }
  };

  const onPageShow = () => restoreSubmit();

  form.addEventListener('invalid', onInvalid, true);
  form.addEventListener('input', onInput);
  form.addEventListener('submit', onSubmit);
  form.addEventListener('reset', restoreSubmit);
  window.addEventListener('pageshow', onPageShow);

  if (message?.value) {
    message.value = message.value.slice(0, message.maxLength);
  }

  if (success) requestAnimationFrame(() => success.focus());

  PILLOW_CONTACT_INSTANCES.set(root, () => {
    form.removeEventListener('invalid', onInvalid, true);
    form.removeEventListener('input', onInput);
    form.removeEventListener('submit', onSubmit);
    form.removeEventListener('reset', restoreSubmit);
    window.removeEventListener('pageshow', onPageShow);
    PILLOW_CONTACT_INSTANCES.delete(root);
  });
}

function initPillowWithin(scope = document) {
  markPillowAssetsReady(scope);

  const page = scope.matches?.(PILLOW_TEMPLATE_SELECTOR)
    ? scope
    : scope.querySelector?.(PILLOW_TEMPLATE_SELECTOR);
  const searchRoot = page || scope;

  if (searchRoot.matches?.(PILLOW_CONTACT_SELECTOR)) {
    initPillowContact(searchRoot);
  }
  searchRoot.querySelectorAll?.(PILLOW_CONTACT_SELECTOR).forEach(initPillowContact);
}

function destroyPillowWithin(scope) {
  if (!scope) return;

  const roots = scope.matches?.(PILLOW_CONTACT_SELECTOR)
    ? [scope]
    : Array.from(scope.querySelectorAll?.(PILLOW_CONTACT_SELECTOR) || []);

  roots.forEach((root) => PILLOW_CONTACT_INSTANCES.get(root)?.());
}

initPillowWithin();

document.addEventListener('shopify:section:load', (event) => {
  initPillowWithin(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyPillowWithin(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const contact = event.target?.closest?.(PILLOW_CONTACT_SELECTOR);
  if (!contact) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  event.target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
});
